import React from 'react';
import { motion } from 'framer-motion';
import { CompeteIcon, StormIcon, MarketingIcon } from './CustomIcons';
const problems = [{
  title: 'El Cáncer de los Leads Compartidos',
  body: <>
        Cuando el cliente recibe 5 llamadas en 10 minutos, su único criterio es:{' '}
        <strong className="text-white font-bold" data-id="element-74">¿Quién me cobra menos?</strong>{' '}
        Estás compitiendo hacia el abismo de los márgenes bajos.
      </>,
  icon: CompeteIcon
}, {
  title: 'La Trampa del Vendedor de Esperanza',
  body: <>
        Si tu agencia te dice 'espera 3 meses a ver resultados', te están
        robando. Un sistema de Roofing profesional inyecta leads en{' '}
        <strong className="text-white font-bold" data-id="element-75">72 horas.</strong>
      </>,
  icon: StormIcon
}, {
  title: 'El Sistema Frágil',
  body: <>
        Si dependes de que caiga granizo o una tormenta para facturar, tu
        negocio es inestable.{' '}
        <strong className="text-white font-bold" data-id="element-76">
          El Sistema A.C.E.™ genera demanda aunque el cielo esté despejado.
        </strong>
      </>,
  icon: MarketingIcon
}];
export function DiagnosisSection() {
  return <section className="py-16 md:py-24 px-4 bg-carbon" data-id="element-77">
      <div className="max-w-4xl mx-auto" data-id="element-78">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-2xl md:text-4xl font-heading font-bold text-gold text-center mb-6 md:mb-8" data-id="element-79">
          La razón real por la que estás dejando de ganar $20k mensuales.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-base md:text-lg text-white text-center max-w-3xl mx-auto mb-10 md:mb-16 leading-relaxed" data-id="element-80">
          Te han vendido la idea de que el Roofing es un juego de volumen.
          'Compra más leads y cerrarás más'.{' '}
          <strong className="text-gold font-bold" data-id="element-81">Mentira.</strong> Eso solo
          enriquece a las plataformas de leads.
        </motion.p>

        <div className="space-y-4 md:space-y-6" data-id="element-82">
          {problems.map((problem, index) => {
          const Icon = problem.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="bg-[#0A0A0A] border border-[#151515] border-t-2 border-t-gold/50 p-5 md:p-8 rounded-lg flex flex-col md:flex-row gap-4 md:gap-6 items-start shadow-lg" data-id="element-83">
                <div className="bg-gold/10 p-3 rounded-full shrink-0" data-id="element-84">
                  <Icon className="w-6 h-6 text-gold" data-id="element-85" />
                </div>
                <div data-id="element-86">
                  <h3 className="text-lg md:text-xl font-bold text-white mb-2 leading-tight" data-id="element-87">
                    {problem.title}
                  </h3>
                  <p className="text-base text-gray-sec leading-relaxed" data-id="element-88">
                    {problem.body}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}